import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { AuthService } from '../Services/AuthService';
import { routes } from './routes';

/**
 * Shared by Home and Login, the two entrances to the app: both sign in the
 * same way and both land in the same place. Kept in one place so "sign in"
 * is one behaviour rather than two copies that can drift.
 */
export function useGoogleSignIn() {
  const navigate = useNavigate();
  const [busy, setBusy] = useState(false);
  const [failed, setFailed] = useState(false);

  async function signIn() {
    setBusy(true);
    setFailed(false);
    try {
      const user = await AuthService.signInWithGoogle();
      // A closed popup returns null with no error: the visitor changed their
      // mind, not a failure, and there is nowhere to navigate to.
      if (user) navigate(routes.dashboard);
    } catch (error) {
      console.error('[auth] sign-in failed', error);
      setFailed(true);
    } finally {
      setBusy(false);
    }
  }

  return { signIn, busy, failed };
}
